<script setup>
import { computed } from 'vue'
import { langUrl, openPopup } from '@/helpers'
import { storeToRefs } from 'pinia'
import { useLangStore } from '@/stores/app/lang'
import { useMenuStore } from '@/stores/gallery/menu'

const { lang } = storeToRefs(useLangStore())
const { category } = storeToRefs(useMenuStore())

// State -----------------------------------------

// Getters ---------------------------------------
const btnDescVisible = computed(() => {
  return category.value < 4 ? 'visible' : 'hidden'
})

const btnListImage = computed(() => {
  switch (category.value) {
    case 4:
      return langUrl(`/images/main/th/btn-list-bags.png`)
    case 5:
      return langUrl(`/images/main/th/btn-list-cloths.png`)
    default:
      return langUrl(`/images/main/th/btn-list-fans.png`)
  }
})
// Methods ---------------------------------------

// Events ----------------------------------------
function onClickBtnDesc() {
  console.log('[PopupDesc] open ...')
  openPopup('PopupDesc')
}
function onClickBtnList() {
  console.log('[PopupList] open ...')
  openPopup('PopupList')
}

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <transition name="fade-lang">
    <div class="main-nav" :key="lang" :lang="lang">
      <img
        :style="{ visibility: btnDescVisible }"
        class="btn"
        :src="langUrl(`/images/main/th/btn-desc.png`)"
        @click="onClickBtnDesc()"
      />
      <img class="btn" :src="btnListImage" @click="onClickBtnList()" />
    </div>
  </transition>
</template>

<style scoped>
.main-nav {
  position: absolute;
  width: 468px;
}

.btn {
  margin: 0 auto;
  cursor: pointer;
}
</style>
